import React, { useMemo, useState } from 'react';
import { LANGUAGE_EN } from '@home/_config/config';
import { getLocale, useIntl } from 'umi';
import { getName } from '@home/utils/common';
import Change from '@/pages/aigc/pages/Agent/svg/change-blue.svg';
import ChangeGrey from '@/pages/aigc/pages/Agent/svg/change-grey.svg';
import Ask from '@/pages/aigc/pages/Agent/svg/agent-ask.svg';
import Arrow from '@/pages/aigc/pages/Agent/svg/agent-arrow.svg';
import Loading from '@home/components/Loading';
interface IQuestionItem {
  name: string;
  name_cn: string;
}

interface ICopilotQuestionListProps {
  data: IQuestionItem[];
  loading: boolean;
  handleClickRecommend?: (question: string) => void;
  /** 单次展示的推荐问题条数（默认 2 条） */
  batchSize?: number;
}

/**
 * Copilot 首页「推荐」列表：单次展示固定条数（见组件内 BATCH_SIZE），支持换一批。
 */
export const CopilotQuestionList: React.FC<ICopilotQuestionListProps> = ({
  data,
  loading,
  handleClickRecommend,
  batchSize = 2,
}) => {
  const [currentIndex, setCurrentIndex] = useState<number>(0);
  const locale = getLocale();
  const [isHover, setIshover] = useState<boolean>(false);
  const { formatMessage } = useIntl();
  const isEN = locale === LANGUAGE_EN;
  /** Copilot 首页单次展示的推荐问题条数（轻量化：默认 2 条） */
  const BATCH_SIZE = batchSize;

  // 每次截取 BATCH_SIZE 个问题
  const { visibleData, showRefresh } = useMemo(() => {
    if (!data || data.length === 0)
      return { visibleData: [], showRefresh: false };

    // 计算当前批次的问题
    const endIndex = currentIndex + BATCH_SIZE;
    let slicedData: IQuestionItem[] = [];

    // 若尾部不足一页，则从列表开头补足至 BATCH_SIZE 条
    if (endIndex > data.length) {
      const remaining = endIndex - data.length;
      slicedData = [...data.slice(currentIndex), ...data.slice(0, remaining)];
    } else {
      slicedData = data.slice(currentIndex, endIndex);
    }

    return {
      visibleData: slicedData,
      showRefresh: data.length > BATCH_SIZE,
    };
  }, [data, currentIndex]);

  const handleRefresh = () => {
    // 计算下一个起始位置，如果到底则从头开始
    setCurrentIndex((prev) => {
      const nextIndex = prev + BATCH_SIZE;
      return nextIndex >= data.length ? 0 : nextIndex;
    });
  };

  // 实现页面跳转
  const handleClickQuestion = (task: IQuestionItem) => {
    handleClickRecommend?.(isEN ? task.name : task.name_cn);
  };

  if (loading) return <Loading style={{ height: '200px' }} />;
  return (
    <div className="dba-copilot-recommend-container" key={currentIndex}>
      <div className="dba-may-ask">
        <div className="dba-ask-title">
          <div  className="dba-ask-title-left">
            <img src={Ask} />
            <span>
              {formatMessage({ id: 'dba_copilot_sidebar_recommend_title' })}
            </span>
          </div>
          {showRefresh && (
            <div
              className="dba-copilot-recommend-container-item-refresh-icon"
              onClick={handleRefresh}
              onMouseEnter={() => setIshover(true)}
              onMouseLeave={() => setIshover(false)}
            >
              <img
                src={isHover ? Change : ChangeGrey}
                alt="change-icon"
                className="dba-change-icon"
              />
              {formatMessage({ id: 'dba_change_list' })}
            </div>
          )}
        </div>
         
        <div className="dba-ask-content">
          {visibleData?.map((item: IQuestionItem, index: number) => (
            <div
              key={index}
              className="dba-ask-single"
              onClick={() => handleClickQuestion(item)}
            >
              <span className="dba-ask-text">
                {getName(isEN, item.name, item.name_cn)}
              </span>
              <img src={Arrow} />
            </div>
          ))}
        </div>
      </div>
    
    </div>
  );
};
